/**
 * Csv Schema of Sistema
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {Sistema} from '@/model/resource/Sistema'

/* TODO: review generated schema */
export class CsvSistemaSchema extends Schema {
  readonly name = 'CsvSistema'

  readonly fieldSet: FieldSet<Sistema> = {
    idSistemaPk: schema => schema.model.idSistemaPk,
    nome: schema => schema.model.nome,
    ativo: schema => Helper.bool(schema.model.ativo),
  }
}
